import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import $ from 'jquery';
import { languageSettings } from '../lenguajeDatatable';
import 'datatables.net';

@Component({
  selector: 'app-codigo-gestos',
  templateUrl: './codigo-gestos.component.html',
  styleUrl: './codigo-gestos.component.css',
})
export class CodigoGestosComponent implements OnInit, AfterViewInit {
  estadosCiviles: any[] = [];
  parentescos: any[] = [];
  tablaEstadosCiviles: any;
  tablaParentescos: any;

  constructor(
    private apiService: ApiService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.cargarEstadosCiviles();
    this.cargarParentescos();
  }

  ngAfterViewInit(): void {
    this.configurarValidacionInputs();
  }

  configurarValidacionInputs(): void {
    $(document).on(
      'keypress',
      '.codigo-gestos-ec, .codigo-gestos-p',
      (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          event.preventDefault();
          return false;
        }
        return true;
      }
    );

    $(document).on('blur', '.codigo-gestos-ec, .codigo-gestos-p', (event) => {
      const input = $(event.target);
      const valor = input.val() as string;

      if (valor && !/^\d+$/.test(valor)) {
        const valorLimpio = valor.replace(/[^\d]/g, '');
        input.val(valorLimpio);
      }
    });

    $(document).on('paste', '.codigo-gestos-ec, .codigo-gestos-p', (event) => {
      const clipboardData = (event.originalEvent as ClipboardEvent)
        ?.clipboardData;
      if (clipboardData) {
        const textoPegado = clipboardData.getData('text');
        if (!/^\d*$/.test(textoPegado)) {
          event.preventDefault();
          return false;
        }
      }
      return true;
    });
  }

  cargarEstadosCiviles(): void {
    this.loadingService.setLoading(true);
    this.apiService.obtenerEstadosCiviles().subscribe({
      next: (datos) => {
        this.estadosCiviles = datos;
        this.inicializarTablaEstadosCiviles();
        this.loadingService.setLoading(false);
      },
      error: (error) => {
        this.toastService.mostrarNotificacion(
          'Error al cargar los estados civiles',
          'error'
        );
        this.loadingService.setLoading(false);
      },
    });
  }

  cargarParentescos(): void {
    this.loadingService.setLoading(true);
    this.apiService.obtenerParentesco().subscribe({
      next: (datos) => {
        this.parentescos = datos;
        this.inicializarTablaParentescos();
        this.loadingService.setLoading(false);
      },
      error: (error) => {
        this.toastService.mostrarNotificacion(
          'Error al cargar los parentescos',
          'error'
        );
        this.loadingService.setLoading(false);
      },
    });
  }

  inicializarTablaEstadosCiviles(): void {
    if (this.tablaEstadosCiviles) {
      this.tablaEstadosCiviles.destroy();
    }

    setTimeout(() => {
      this.tablaEstadosCiviles = $('#tablaEstadosCiviles').DataTable({
        data: this.estadosCiviles.map((ec) => [
          ec.id,
          ec.codigoGestos ?? '',
          ec.descripcion,
        ]),
        language: languageSettings,
        columns: [
          { title: 'ID', visible: false },
          {
            title: 'Código Gestos',
            className: 'columna-codigo',
            render: (data, type, row) => {
              if (type === 'display') {
                return `<input type="number" class="form-control codigo-gestos-ec" value="${data}" min="0" step="1" data-id="${row[0]}">`;
              }
              return data;
            },
          },
          {
            title: 'Descripción',
            className: 'columna-descripcion',
          },
        ],
        dom: 'rt',
        pageLength: 25,
        responsive: true,
        autoWidth: false,
      });
    }, 0);
  }

  inicializarTablaParentescos(): void {
    if (this.tablaParentescos) {
      this.tablaParentescos.destroy();
    }

    setTimeout(() => {
      this.tablaParentescos = $('#tablaParentescos').DataTable({
        data: this.parentescos.map((p) => [
          p.id,
          p.codigoGestos ?? '',
          p.descripcion,
        ]),
        language: languageSettings,
        columns: [
          { title: 'ID', visible: false },
          {
            title: 'Código Gestos',
            className: 'columna-codigo',
            render: (data, type, row) => {
              if (type === 'display') {
                // Solo permitir números enteros
                return `<input type="number" class="form-control codigo-gestos-p" value="${data}" min="0" step="1" data-id="${row[0]}">`;
              }
              return data;
            },
          },
          {
            title: 'Descripción',
            className: 'columna-descripcion',
          },
        ],
        dom: 'rt',
        pageLength: 25,
        responsive: true,
        autoWidth: false,
      });
    }, 0);
  }

  validarNumeroEntero(valor: any): number | null {
    if (valor === null || valor === '') {
      return null;
    }

    const numeroEntero = parseInt(valor, 10);

    if (
      isNaN(numeroEntero) ||
      !Number.isInteger(numeroEntero) ||
      numeroEntero < 0
    ) {
      return null;
    }

    return numeroEntero;
  }

  guardarCodigosEstadosCiviles(): void {
    const estadosCivilesActualizados: any[] = [];

    $('.codigo-gestos-ec').each((index, element) => {
      const input = $(element);
      const id = input.data('id');
      const codigoGestos = this.validarNumeroEntero(input.val());

      const estadoCivil = this.estadosCiviles.find((ec) => ec.id === id);
      if (estadoCivil) {
        estadosCivilesActualizados.push({
          ...estadoCivil,
          codigoGestos: codigoGestos,
        });
      }
    });

    if (estadosCivilesActualizados.length > 0) {
      this.loadingService.setLoading(true);

      this.apiService
        .actualizarCodigosEstadosCiviles(estadosCivilesActualizados)
        .subscribe({
          next: (respuesta) => {
            this.toastService.mostrarNotificacion(
              'Códigos de estados civiles actualizados correctamente',
              'success'
            );
            this.cargarEstadosCiviles();
          },
          error: (error) => {

            this.toastService.mostrarNotificacion(
              'Error al guardar los códigos de estados civiles',
              'error'
            );
            this.loadingService.setLoading(false);
          },
        });
    }
  }

  guardarCodigosParentescos(): void {
    const parentescosActualizados: any[] = [];

    $('.codigo-gestos-p').each((index, element) => {
      const input = $(element);
      const id = input.data('id');
      const codigoGestos = this.validarNumeroEntero(input.val());

      const parentesco = this.parentescos.find((p) => p.id === id);
      if (parentesco) {
        parentescosActualizados.push({
          ...parentesco,
          codigoGestos: codigoGestos,
        });
      }
    });

    if (parentescosActualizados.length > 0) {
      this.loadingService.setLoading(true);

      this.apiService
        .actualizarCodigosParentescos(parentescosActualizados)
        .subscribe({
          next: (respuesta) => {
            this.toastService.mostrarNotificacion(
              'Códigos de parentescos actualizados correctamente',
              'success'
            );
            this.cargarParentescos();
          },
          error: (error) => {
          
            this.toastService.mostrarNotificacion(
              'Error al guardar los códigos de parentescos',
              'error'
            );
            this.loadingService.setLoading(false);
          },
        });
    }
  }
}
